const tagLines = [
  "Driving innovation through software excellence",
  "Innovate. Create. Transform",
  "Empowering progress through digital excellence",
  "Building Bridges with Bespoke Software Solutions",
  "Your Vision, Our Code",
];

export default tagLines;
